// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__ANQ3j","header":"ReportDetails_header__9m4Aq","title":"ReportDetails_title__3RqLp","left":"ReportDetails_left__2L225"};